const Projects = [
  {
    title: 'Milton',
    name: 'Milton',
    route: '/portfolio/Milton',
    thumb: require('../img/projects/Milton_9.jpg'),
    banner: require('../img/projects/Milton_banner.jpg'),
    content: [
      {
        img: require('../img/projects/Milton_1.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/Milton_2.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Milton_3.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Milton_4.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Milton_5.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/Milton_6.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/Milton_7.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Milton_8.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Milton_9.jpg'),
        orientation: 'landscape',
      },
    ],
  },
  {
    title: 'Cumming',
    name: 'Cumming',
    route: '/portfolio/Cumming',
    thumb: require('../img/projects/Cumming_9.jpg'),
    banner: require('../img/projects/Cumming_banner.jpg'),
    content: [
      {
        img: require('../img/projects/Cumming_1.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_2.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_3.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_4.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_5.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_6.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_7.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_8.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_9.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_10.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_11.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/Cumming_12.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Cumming_13.jpg'),
        orientation: 'portrait',
      },
    ],
  },
  {
    title: 'Lower Roswell',
    name: 'LowerRoswell',
    route: '/portfolio/LowerRoswell',
    thumb: require('../img/projects/LowerRoswell_3.jpg'),
    banner: require('../img/projects/LowerRoswell_banner.jpg'),
    content: [
      {
        img: require('../img/projects/LowerRoswell_1.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/LowerRoswell_2.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/LowerRoswell_3.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/LowerRoswell_4.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/LowerRoswell_5.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/LowerRoswell_6.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/LowerRoswell_7.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/LowerRoswell_8.jpg'),
        orientation: 'portrait',
      },
    ],
  },
  {
    title: 'East Hampton',
    name: 'EastHampton',
    route: '/portfolio/EastHampton',
    thumb: require('../img/projects/EastHampton_1.JPG'),
    banner: require('../img/projects/EastHampton_banner.JPG'),
    content: [
      {
        img: require('../img/projects/EastHampton_1.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/EastHampton_2.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_3.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_4.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_5.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_6.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_7.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_8.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_9.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/EastHampton_10.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_11.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_12.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_13.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_14.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_15.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/EastHampton_16.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_17.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_18.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/EastHampton_19.JPG'),
        orientation: 'landscape',
      },
    ],
  },
  {
    title: 'East Cobb',
    name: 'EastCobb',
    route: '/portfolio/EastCobb',
    thumb: require('../img/projects/light_and_airy_1.JPG'),
    banner: require('../img/projects/light_and_airy_banner.JPG'),
    content: [
      {
        img: require('../img/projects/light_and_airy_1.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/light_and_airy_2.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/light_and_airy_3.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/light_and_airy_4.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/light_and_airy_5.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/light_and_airy_6.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/light_and_airy_7.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/light_and_airy_8.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/light_and_airy_9.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/light_and_airy_10.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/light_and_airy_11.JPG'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/light_and_airy_12.JPG'),
        orientation: 'landscape',
      },
    ],
  },
  {
    title: 'Roswell',
    name: 'Roswell',
    route: '/portfolio/Roswell',
    thumb: require('../img/projects/Roswell_1.jpg'),
    banner: require('../img/projects/Roswell_banner.png'),
    content: [
      {
        img: require('../img/projects/Roswell_1.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_2.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_3.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_4.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_5.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_6.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_7.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_8.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_9.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_10.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_11.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/Roswell_12.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/Roswell_13.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_14.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_15.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/Roswell_16.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/Roswell_17.jpg'),
        orientation: 'landscape',
      },
    ],
  },
  {
    title: 'West Paces',
    name: 'WestPaces',
    route: '/portfolio/WestPaces',
    thumb: require('../img/projects/antique_elegance_1.jpg'),
    banner: require('../img/projects/antique_elegance_banner.png'),
    content: [
      {
        img: require('../img/projects/antique_elegance_1.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/antique_elegance_2.jpg'),
        orientation: 'landscape',
      },
    ],
  },
  {
    title: 'Marietta',
    name: 'Marietta',
    route: '/portfolio/Marietta',
    thumb: require('../img/projects/tranquil_living_1.jpg'),
    banner: require('../img/projects/tranquil_living_banner.png'),
    content: [
      {
        img: require('../img/projects/tranquil_living_1.jpg'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/tranquil_living_2.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/tranquil_living_3.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/tranquil_living_4.jpg'),
        orientation: 'portrait',
      },
    ],
  },
  {
    title: 'Buckhead',
    name: 'Buckhead',
    route: '/portfolio/Buckhead',
    thumb: require('../img/projects/historic_georgian_1.jpg'),
    banner: require('../img/projects/historic_georgian_banner_1.png'),
    content: [
      {
        img: require('../img/projects/historic_georgian_1.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/historic_georgian_2.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/historic_georgian_3.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/historic_georgian_4.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/historic_georgian_5.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/historic_georgian_6.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/historic_georgian_7.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/historic_georgian_8.jpg'),
        orientation: 'portrait',
      },
    ],
  },
  {
    title: 'Druid Hills',
    name: 'DruidHills',
    route: '/portfolio/DruidHills',
    thumb: require('../img/projects/classic_beauty_1.jpg'),
    banner: require('../img/projects/classic_beauty_banner_1.png'),
    content: [
      {
        img: require('../img/projects/classic_beauty_1.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_2.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_3.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_4.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_5.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_6.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_7.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_8.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_9.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_10.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_11.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_12.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_13.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_14.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/classic_beauty_15.jpg'),
        orientation: 'portrait',
      },
    ],
  },
  {
    title: 'Providence',
    name: 'Providence',
    route: '/portfolio/Providence',
    thumb: require('../img/projects/french_quarter_kitchen_1.JPG'),
    banner: require('../img/projects/french_quarter_kitchen_banner.JPG'),
    content: [
      {
        img: require('../img/projects/french_quarter_kitchen_1.JPG'),
        orientation: 'landscape',
      },
      {
        img: require('../img/projects/french_quarter_kitchen_2.JPG'),
        orientation: 'landscape',
      },
    ],
  },
  {
    title: 'Indian Hills',
    name: 'IndianHills',
    route: '/portfolio/IndianHills',
    thumb: require('../img/projects/country_french_laundry_1.jpg'),
    banner: require('../img/projects/country_french_laundry_banner.jpg'),
    content: [
      {
        img: require('../img/projects/country_french_laundry_1.jpg'),
        orientation: 'portrait',
      },
      {
        img: require('../img/projects/country_french_laundry_2.jpg'),
        orientation: 'portrait',
      },
    ],
  },
];

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects.js